import { Spinner } from "@/components/ui/modal";
import { cn } from "@/lib/utils";

/** loading 蒙层组件 */
export const LoadingOverlay = ({
  loading,
  className,
  showIcon = true,
  icon,
  text = ''
}: {
  loading: boolean;
  className?: string;
  showIcon?: boolean;
  icon?: React.ReactNode;
  text?: string;
}) => {
  if (!loading) return null;

  return (
    <div className={cn(
      'absolute inset-0 w-full h-full flex flex-col gap-4 items-center justify-center bg-white/75 z-[9999]',
      className
    )}>
      {showIcon && (icon ? icon : <Spinner />)}
      {text && <p className="text-sm text-gray-600">{text}</p>}
    </div>
  )
}